import React from 'react';
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";
import {StandingsWidgetSectionIconTitle} from "../standings-widget.section-icon-title";
import {StandingsWidgetPointsDeductionsRows} from "./standings-widget.points-deductions.rows";
import {PointsDeductionsHammerRequestParams} from "../../../../core/icons/points-deductions.hammer.request-params";

export const StandingsWidgetPointsDeductions = ({controller, isPreviewStandings}) => {
  const {state} = controller;
  const {pointsDeductions, pointsDeductionsTitle, isCollapsed} = state;

  if(!pointsDeductions || isPreviewStandings || isCollapsed) {
    return null;
  }

  const titleProps = {
    controller,
    label: pointsDeductionsTitle,
    iconSource: new PointsDeductionsHammerRequestParams(24,24)
  }

  return (
    <div className={classNames(styles.points_deductions)}>
      <StandingsWidgetSectionIconTitle {...titleProps}/>
      <StandingsWidgetPointsDeductionsRows controller={controller}/>
    </div>
  )
};